import { agent } from "@shared/services/agent";

export function favouriteUserRequest(userId: string, favouritingUser: string, add: boolean): Promise<any> {
  return agent.requests.post('/api/favourite-user', {
    userId: userId, favouritedUser: favouritingUser, add: add
  })
}
